import { memo, RefAttributes } from 'react';
import { TextField as RACTextField, TextFieldProps as RACTextFieldProps } from 'react-aria-components';

import { merge } from '@/components';

export type TextFieldProps = RACTextFieldProps & RefAttributes<HTMLDivElement>;

const ITextField = ({ children, className, ...rest }: TextFieldProps) => {
  // eslint-disable-next-line prettier/prettier
  const styles = [
    'group/text-field',
    'flex',
    'flex-col',
    'gap-xs'
  ];

  return (
    <RACTextField aria-label="textfield" className={merge(styles, className)} {...rest}>
      {children}
    </RACTextField>
  );
};

export const TextField = memo(ITextField) as typeof ITextField;
